import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useContractsList() {
  // Use toast
  const toast = useToast();

  const refContractListTable = ref(null);

  const idFilter = ref(null)
  const dateFilter = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: "contract_number", label: "合約編號", sortable: true },
    { key: "supplier_name_cn", label: "放債人名稱", sortable: true },
    { key: "loan_date", label: "貸款日期" },
    { key: "name_cn", label: "借款人姓名" },
    { key: "id_number", label: "身份證號碼" },
    { key: "amount", label: "貸款本金", sortable: true },
    { key: "is_monthly", label: "供款週期", sortable: true },
    { key: "period", label: "總期數", sortable: true },
    { key: "status", label: "合約狀態", sortable: true },
    { key: "is_signed", label: "已簽署", sortable: true },
    // { key: "actions" , label: "操作"},
  ];
  const perPage = ref(10);
  const totalContracts = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);
  const contractsList = ref([])

  const dataMeta = computed(() => {
    const localItemsCount = refContractListTable.value
      ? refContractListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalContracts.value,
    };
  });

  const refetchData = () => {
    refContractListTable.value.refresh();
  };

  watch(
    [currentPage, perPage, searchQuery, idFilter, dateFilter],
    () => {
      refetchData();
    }
  );

  if(router.currentRoute.params.id_number)
      idFilter.value = router.currentRoute.params.id_number

  const today_total_contract = ref(null);
  const today_total_amount = ref(null);
  const is_oca = ref(0)
  const is_bad_debt = ref(0)
  const fetchContracts = (ctx, callback) => {
    if (router.currentRoute.name == "oca-list") {
      is_oca.value = 1
      is_bad_debt.value = 0
    }else if (router.currentRoute.name == "pi-list") {
      is_oca.value = 0
      is_bad_debt.value = 1
    }
    store
      .dispatch("app-contract/fetchContracts", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        id_number: idFilter.value,
        date: dateFilter.value,
        is_oca: is_oca.value,
        is_bad_debt: is_bad_debt.value,
      })
      .then((response) => {
        const { contracts, total } = response.data;
        callback(contracts);
        // console.log(contracts)
        contractsList.value = contracts
        today_total_contract.value = response.data.today_total_contract
        today_total_amount.value = response.data.today_total_amount
        totalContracts.value = total;
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  return {
    fetchContracts,
    tableColumns,
    perPage,
    currentPage,
    totalContracts,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refContractListTable,
    ability,
    contractsList,
    refetchData,
    idFilter,
    dateFilter,
    today_total_amount,
    today_total_contract,
    is_oca,
    is_bad_debt
  };
}
